import { API } from './axios';

const getUserProfile = async () => {
  try {
    const res = await API.get('/users/me');
    return res.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
  }
};

const postUserProfile = async (userData, userId) => {
  try {
    const res = await API.put(`/users/${userId}`, userData);
    return res.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
  }
};
const updateProfile = async (data) => {
  try {
    const res = await API.put('/users/me', data);
    console.log('User updated:', res.data);
  } catch (error) {
    console.error(
      'Error updating user:',
      error.response?.data || error.message
    );
  }
};

export { getUserProfile, postUserProfile, updateProfile };
